import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import Navigation from "../components/Navigation";
import Carousel from "../components/Carousel";
import Form from "../components/QuestionForm";
import Title from "../components/Title";
import SpecialList from "../components/SpecialList";
import {
  AddVehicleToFavorites,
  getAdminDefaults,
  getVehicle,
  getVehiclesByCategory,
} from "../services/btc-api.service";
import { initUserSession } from "../services/auth.service";
import { CONSTANTS } from "./../shared/constants";
import { useMediaQuery } from "react-responsive";
import { store } from "../redux/store";
import { setIsGlobalModalOpen } from "../redux/modal";
import { setModalData } from "../redux/modal";
import { AngleDown } from "../icons";
var imageBasePath =
  window.location.protocol + "//" + window.location.host + "/";

export default function Single() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [vehicle, setVehicle] = useState({});
  const [bidStatus, setBidStatus] = useState({});
  const [isFavorite, setIsFavorite] = useState({});
  const [images, setImages] = useState([]);
  const user = useSelector((state) => state.user.user);
  const [relatedProducts, setRelatedProducts] = useState([]);
  const [adminDefaults, setAdminDefaults] = useState({
    serviceCenterOperationCharges: 0,
  });
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    if (selectedImage) {
      setImages([selectedImage, ...images]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedImage]);

  const getVehicleDetails = async () => {
    const res = await getVehicle(id, user && user._id ? user._id : undefined);

    setVehicle(res.vehicle);
    setIsFavorite(res.isFavorite);
    setBidStatus(res.bidStatus);
    fetchVehiclesByCategory(res.vehicle.bodyType);

    setImages([res.vehicle.thumbnail, ...res.vehicle.pictures]);
  };

  const addFavorite = async () => {
    if (user && user._id) {
      await AddVehicleToFavorites(user._id, {
        auctionType: vehicle.auctionType,
        vehicleId: vehicle._id,
      });

      await initUserSession();

      setIsFavorite(!isFavorite);
    } else {
      navigate("/login");
    }
  };

  const fetchVehiclesByCategory = async (category) => {
    const res = await getVehiclesByCategory(category);

    if (res.records) {
      setRelatedProducts(res.records);
    }
  };

  const getAndSetAdminDefaults = async () => {
    try {
      const res = await getAdminDefaults();

      setAdminDefaults({
        ...res,
      });
    } catch (error) {}
  };

  useEffect(() => {
    getVehicleDetails();
    getAndSetAdminDefaults();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="single-page">
      <Navigation breadcrumb={`Home > Car Details > ${vehicle.name}`} />
      <div className="navigation-button-single">
        <div className="single-heading">
          {!isMobile && (
            <span>
              NO.{vehicle.auctionNo} {vehicle.name}{" "}
            </span>
          )}
        </div>
        <div className="single-btn">
          <Navigation
            buttons
            vehicleNo={vehicle.auctionNo}
            vehicleName={vehicle.name}
            onClickFav={addFavorite}
            isFavorite={isFavorite}
            condition={vehicle.condition}
          />
        </div>
      </div>
      <div
        style={{
          display: "flex",
          gap: "7%",
          alignItems: "start",
          justifyContent: "center",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        <div className="left-side">
          <Carousel items={images} selectedImage={selectedImage} />
          <Gallery vehicle={vehicle} setSelectedImage={setSelectedImage} />
          {/* {!isMobile && <Form vehicle={vehicle} user={user} />} */}
        </div>
        <div className="right-side">
          <LiveBids
            vehicle={vehicle}
            bidStatus={bidStatus}
            user={user}
            adminDefaults={adminDefaults}
          />
          <Information vehicle={vehicle} />
        </div>
      </div>
      {isMobile && <Form vehicle={vehicle} user={user} />}
      <div className="container">
        <Title text={"related Products"} />
        <SpecialList isRelated={true} specialOffers={relatedProducts} />
      </div>
    </div>
  );
}

const Gallery = ({ vehicle, setSelectedImage }) => {
  return (
    <div className="gallery">
      {vehicle &&
        vehicle.pictures &&
        vehicle.pictures.map((url, index) => (
          <img
            onClick={() => {
              setSelectedImage(url);
            }}
            key={index}
            src={`${process.env.REACT_APP_BTC_API_URL}/${url}`}
            alt={`Car ${index + 1}`}
          />
        ))}
    </div>
  );
};

const LiveBids = ({ vehicle, bidStatus, user, adminDefaults }) => {
  const navigate = useNavigate();
  const [clock, setClock] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [timeUp, setTimeUp] = useState(true);

  useEffect(() => {
    const updateClock = () => {
      if (vehicle.auctionEndDate) {
        const dateObj = new Date(vehicle.auctionEndDate);
        const dateObjWithTime = new Date(dateObj.toISOString().slice(0, -1));

        const japanDateTime = new Date().toLocaleString("en-US", {
          timeZone: "Asia/Tokyo",
        });
        const japanDateTimeObj = new Date(japanDateTime);

        const total = dateObjWithTime.getTime() - japanDateTimeObj.getTime();
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
        const days = Math.floor(total / (1000 * 60 * 60 * 24));

        if (total <= 0) {
          setClock({
            days: 0,
            hours: 0,
            minutes: 0,
            seconds: 0,
          });
          clearInterval(timeIntervalId);
          setTimeUp(true);
        } else {
          setClock({
            days,
            hours,
            minutes,
            seconds,
          });
          setTimeUp(false);
        }
      }
    };

    updateClock();
    const timeIntervalId = setInterval(updateClock, 1000);

    return () => {
      clearInterval(timeIntervalId);
    };
  }, [vehicle]);

  const onClickbid = async () => {
    if (user && user._id) {
      store.dispatch(setIsGlobalModalOpen(true));
      store.dispatch(
        setModalData({
          auctionType: vehicle.auctionType,
          currentPrice: bidStatus.currentPrice,
          vehicleId: vehicle._id,
        })
      );
    } else {
      navigate("/login");
    }
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div className="bids-header">
          {vehicle && vehicle.auctionType && (
            <h2>
              {vehicle.auctionType === "SUGGESTIONS"
                ? "Negotiation"
                : vehicle.auctionType.toLowerCase()}{" "}
              Auction
            </h2>
          )}
          {vehicle?.auctionType === CONSTANTS.AUCTION_TYPES.LIVE &&
            bidStatus?.currentPrice >= vehicle?.reservedPrice && (
              <button>Reserved Price Met</button>
            )}
        </div>
        {vehicle &&
          vehicle.discountPrice &&
          bidStatus.currentPrice &&
          adminDefaults &&
          adminDefaults.serviceCenterOperationCharges &&
          vehicle.auctionType === CONSTANTS.AUCTION_TYPES.LIVE && (
            <table className="bids-table">
              <tr>
                <td className="bold-and-black">Start Price</td>
                <td className="bold-and-black">
                  {vehicle.discountPrice.toLocaleString()} JPY
                </td>
              </tr>
              <tr>
                <td className="bold-and-black">Current Price</td>
                <td>{bidStatus.currentPrice.toLocaleString()} JPY</td>
              </tr>
              <tr>
                <td>Total Price</td>
                <td>
                  {(
                    CONSTANTS.GET_TAX_PRICE(bidStatus.currentPrice) +
                    bidStatus.currentPrice +
                    adminDefaults.serviceCenterOperationCharges
                  ).toLocaleString()}{" "}
                  JPY
                </td>
              </tr>
              <tr>
                <td>Time left: </td>
                <td>
                  {clock.days > 1 ? clock.days + "days" : clock.days + "day"} ＋
                  {clock.hours < 10
                    ? +"0" + clock.hours.toString()
                    : clock.hours}
                  :
                  {clock.minutes < 10
                    ? +"0" + clock.minutes.toString()
                    : clock.minutes}
                  :
                  {clock.seconds < 10
                    ? +"0" + clock.seconds.toString()
                    : clock.seconds}
                </td>
              </tr>
            </table>
          )}
        {vehicle &&
          vehicle.discountPrice &&
          vehicle.auctionType !== CONSTANTS.AUCTION_TYPES.LIVE && (
            <table className="bids-table" style={{ border: "2px solid white" }}>
              <tbody>
                <tr>
                  <td className="bold-and-black">BTC Offer Price</td>
                  <td className="bold-and-black">
                    {vehicle.discountPrice.toLocaleString()}JPY
                  </td>
                </tr>
                <tr>
                  <td className="bold-and-black">Time left:</td>
                  <td className="bold-and-black">
                    {clock.days > 1 ? clock.days + "days" : clock.days + "day"}
                    ＋
                    {clock.hours < 10
                      ? +"0" + clock.hours.toString()
                      : clock.hours}
                    :
                    {clock.minutes < 10
                      ? +"0" + clock.minutes.toString()
                      : clock.minutes}
                    :
                    {clock.seconds < 10
                      ? +"0" + clock.seconds.toString()
                      : clock.seconds}
                  </td>
                </tr>
              </tbody>
            </table>
          )}
        <button disabled={timeUp} onClick={onClickbid} className="bid-btn">
          <img
            src={imageBasePath + "hammer.png"}
            alt={imageBasePath + "hammer.png"}
          />
          {vehicle.auctionType === CONSTANTS.AUCTION_TYPES.LIVE
            ? "Bid"
            : "Offer"}
        </button>
      </div>
    </>
  );
};

const Information = ({ vehicle }) => {
  const [selectedTab, setSelectedTab] = React.useState("BasicInfo");

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const items = [
    { model: "Stock No.", key: "auctionNo" },
    { model: "Maker", key: "maker.name" },
    { model: "Model", key: "model" },
    { model: "Grade", key: "grade" },
    { model: "Chassis No.", key: "chassisNo" },
    { model: "Year", key: "year" },
    { model: "Type", key: "bodyType" },
    { model: "Displacement", key: "displacement" },
    { model: "Fuel", key: "fuel" },
    { model: "Engine Type", key: "engineType" },
    { model: "Mileage", key: "mileage" },
    { model: "Colour", key: "color" },
    { model: "Transmission", key: "transmission" },
    { model: "Steering wheel", key: "steeringWheel" },
    { model: "Drive System", key: "driveSystem" },
    { model: "Capacity", key: "capacity" },
  ];

  const otherItems = [
    { model: "Condition", key: "condition" },
    { model: "Damaged Area", key: "mainDamage" },
    { model: "Score", key: "score" },
    { model: "Drive Condition", key: "driveCondition" },
    { model: "Location", key: "currentAddress" },
  ];

  return (
    <div className="info">
      <button
        className={selectedTab === "BasicInfo" ? "selected" : ""}
        onClick={() => handleTabClick("BasicInfo")}
      >
        Basic Info &nbsp;
        <AngleDown />
      </button>
      <button
        className={selectedTab === "OtherInfo" ? "selected" : ""}
        onClick={() => handleTabClick("OtherInfo")}
      >
        Other Info &nbsp;
        <AngleDown />
      </button>
      <table className="details-table">
        <tbody>
          {selectedTab === "BasicInfo" &&
            items.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#ECECEC",
                }}
              >
                <td>{item.model}</td>
                <td>
                  {item.model === "Maker"
                    ? vehicle && vehicle.maker && vehicle.maker.name
                    : vehicle[item.key]}{" "}
                  {item.model === "Displacement" && "cc"}{" "}
                  {item.model === "Mileage" && "Km"}
                </td>
              </tr>
            ))}

          {selectedTab === "OtherInfo" &&
            otherItems.map((item, index) => (
              <tr
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "#FFFFFF" : "#ECECEC",
                }}
              >
                <td>{item.model}</td>
                <td>
                  {item.model === "Maker"
                    ? vehicle && vehicle.maker && vehicle.maker.name
                    : vehicle[item.key]}
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      <textarea
        disabled
        value={vehicle.remarks}
        placeholder="Remarks"
        className="remarks"
      ></textarea>
    </div>
  );
};
